<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/courses/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ترتیب درس دوره ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <draggable-table :items="pluckedCourseItems" :headers="headers"
                             @sorted="sortCourseItem($event)" :key="draggableKey"></draggable-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DraggableTable from "@/components/DraggableTable/DraggableTable";

export default {
  name: "CourseItemOrder",
  components: {DraggableTable},
  data() {
    return {
      courseItems: [],
      pluckedCourseItems: [],
      headers: [
        'شناسه',
        'عنوان',
        'نام دسته بندی',
        'ساخته شده در',
        'ترتیب',
        'وضعیت نمایش',
      ],
      draggableKey: 0
    }
  },
  methods: {
    getCourseItems() {
      this.pluckedCourseItems = [];
      window.axios.get('course/crud/get-full-items/' + this.$route.params.id).then((res) => {
        this.courseItems = res.data.data
        Object.values(this.courseItems).forEach((item) => {
          let pluckedItem = {
            id: item.id,
            title: item.title,
            category_name: item.category_name,
            created_at_fa: item.created_at_fa,
            order: item.pivot.order,
            visibility: item.visibility,
          }
          this.$set(this.pluckedCourseItems, this.pluckedCourseItems.length, pluckedItem)
          this.draggableKey += 1
        })
      })
    },
    sortCourseItem(ids) {
      window.axios.post('course/crud/sort/' + this.$route.params.id, {
        item_ids: ids
      }).then(()=>{
        this.getCourseItems()
      })
    }
  },
  mounted() {
    this.getCourseItems()
  }
}
</script>

<style scoped>

</style>